// ----------------------------------------------------------------------------
// Component: Jotform
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_jotform.scss';
